// The ONE place a stored rate FRACTION becomes a percent string.
//
// 🔴 IT EXISTS BECAUSE THE ALTERNATIVE IS A THIRD COPY ON A MONEY SURFACE.
// `design-system/lib/format.ts` offers only `formatProgressPercent`, which
// CLAMPS to [0,1] and would silently render any rate above 100% as "100%" — so
// it is not a rate renderer at all. What exists instead is a long tail of
// independently-rolled per-file helpers, two of which are BOTH exported as
// `formatPct` with OPPOSITE unit contracts (`pages/capital-markets/shared/format.ts`
// multiplies by 100, `pages/ledgers/ledgerHelpers.ts` does not). Each is correct
// for its own callers, so it is a naming hazard rather than a live bug — but a
// one-argument call auto-completed to the wrong import is a 100x error with no
// type-system signal. The Buyer Consulting Fee helper said all of this and then
// rolled its own anyway; this is that helper's arithmetic, hoisted so the next
// fee does not make a third.
//
// It deliberately takes a NON-NULLABLE number and says nothing about absence.
// Whether a nil means "no such term" (render an em-dash) or "not charged"
// (render 0%) differs PER FEE and is the caller's to decide — collapsing that
// decision in here is how a three-state column starts rendering as two.

/**
 * Render a stored FRACTION (0.025) as a percent string ("2.5%"). Trims trailing
 * zeros, so 0.025 → "2.5%" and 0.03 → "3%". Four places of percent is the same
 * precision as the six places of fraction the `decimal(9,6)` columns hold.
 *
 * 0 renders as "0%". That is a real answer wherever the caller's column can
 * legitimately hold a zero; a caller whose nil means something else must branch
 * BEFORE calling this.
 */
export function formatRateFractionAsPercent(fraction: number): string {
  const pct = fraction * 100;
  return `${Number(pct.toFixed(4))}%`;
}
